import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {IApiResponseBase, IPurchaserJobListingOutput, IRawRestQueryParams} from '../../types';
import {RestQueryParams} from '../base/queryParams';

export function getHistoricalJobsListAPI(
    authToken: string,
    payload?: any,
    params?: IRawRestQueryParams | []
): Observable<IApiResponseBase<IPurchaserJobListingOutput[]>> {
    return palipaliAPI.get(`api/jobs/historical`, new RestQueryParams(params), {
        Authorization: `Bearer ${authToken}`,
    });
}
